export const EMBED_CLASS_NAME = 'h-full min-h-149 w-full max-w-full flex-grow'
